/**
 * 라우터 query 객체에서 undefined/null/빈 문자열 값을 제거합니다.
 * @param {Record<string, unknown>} query
 * @returns {Record<string, unknown>}
 */
export const cleanRouteQuery = (query = {}) => {
  if (!query || typeof query !== 'object') return {}

  const cleaned = {}

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null) return

    if (Array.isArray(value)) {
      const filtered = value.filter(
        (entry) =>
          entry !== undefined &&
          entry !== null &&
          String(entry).trim() !== ''
      )
      if (!filtered.length) return
      cleaned[key] = filtered
      return
    }

    const nextValue = typeof value === 'string' ? value.trim() : value
    if (nextValue === '') return
    cleaned[key] = nextValue
  })

  return cleaned
}

